import {
  GET_TOURNAMENTS_LIST,
  GET_TEAM_LEADERBOARD,
  GET_PLAYER_LEADERBOARD,
} from 'constants/actionTypes';
import Fetch from 'helpers/fetch';
import configs from 'configs';

const { TOURNAMENTS_URL } = configs;

export const fetchTournamentsList = () => async dispatch => {
  const { toursList } = await Fetch.GET(`?action=getTeamToursList`, {
    action: GET_TOURNAMENTS_LIST,
    url: TOURNAMENTS_URL,
    referrerPolicy: 'no-referrer-when-downgrade',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (toursList)
    dispatch({
      type: GET_TOURNAMENTS_LIST,
      payload: toursList,
    });
};

export const fetchTeamLeaderBoard = tourId => async dispatch => {
  const { leaderboard } = await Fetch.GET(
    `?action=getTeamLeaderBoard&tourId=${tourId}&sortBy=score`,
    {
      action: GET_TEAM_LEADERBOARD,
      url: TOURNAMENTS_URL,
      referrerPolicy: 'no-referrer-when-downgrade',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (leaderboard)
    dispatch({
      type: GET_TEAM_LEADERBOARD,
      payload: leaderboard,
    });
};

export const fetchPlayerLeaderBoard = tourId => async dispatch => {
  const { leaders } = await Fetch.GET(
    `?action=getPlayerLeaderBoard&tourId=${tourId}&sortBy=score`,
    {
      action: GET_PLAYER_LEADERBOARD,
      url: TOURNAMENTS_URL,
      referrerPolicy: 'no-referrer-when-downgrade',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (leaders)
    dispatch({
      type: GET_PLAYER_LEADERBOARD,
      payload: leaders,
    });
};
